// extracted by mini-css-extract-plugin
module.exports = {"policy":"Policies_policy__Pln9K","paragraph":"Policies_paragraph__OK4Ib"};